import { useEffect, useState } from "react";
import Button from "../../Button";
import { Url_Pdf, Url_Pdf_Info } from "../../../assets/URL'S/Url_Pdf";
import Loading from "../../../utils/Loading";
import api from "../../../Services/api";
import { Alert } from "../../../utils/Alert";
import {
  Background,
  Cardo,
  DivMain,
  DivSave,
  DivTitle,
  DragAndDropArea2,
  FileDetails,
  FileInfo,
  PdfEmbed,
} from "../CardAddEditProgressao/style";

const CardVerPdfEnviado = ({ Show, setShow, progressaoEdit }) => {
  if (!Show) return null;
  const [fileUrl, setFileUrl] = useState(null);
  const [fileSize, setFileSize] = useState({ bytes: null, kb: null, mb: null, gb: null });
  const [windowSize, setWindowSize] = useState({ width: window.innerWidth, height: window.innerHeight });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({ width: window.innerWidth, height: window.innerHeight });
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (!Show) return null; // Adicione essa verificação para evitar a execução desnecessária do hook
    setLoading(true);
    GetPdf();
  }, [Show, progressaoEdit]);

  async function GetPdf() {
    try {
      const res = await api.get(Url_Pdf(progressaoEdit.pdf), { responseType: "arraybuffer" });
      const blob = new Blob([res.data], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      setFileUrl(url);
      const { data } = await api.get(Url_Pdf_Info(progressaoEdit.pdf));
      setFileSize({
        bytes: data.fileSizeInBytes,
        kb: data.fileSizeInKB,
        mb: data.fileSizeInMB,
        gb: data.fileSizeInGB,
      });
    } catch (error) {
      console.error("Erro ao fazer a requisição", error);
      Alert({ tipo: "Erro", mensagem: error.response.data.erro || "Erro ao visualizar o pdf!" });
    } finally {
      setLoading(false);
    }
  }

  const PC = windowSize.width >= 1000;
  const Poket = windowSize.width <= 600;

  function Fechar(e) {
    e.preventDefault();
    setShow(false);
  }

  return (
    <Background>
      <Cardo>
        <DivTitle>
          <h1>PDF Progressão Parcial</h1>
        </DivTitle>
        <DivMain>
          {loading ? <Loading /> : fileUrl && <PdfEmbed src={fileUrl} type="application/pdf" title="PDF Viewer" />}
        </DivMain>
        <DivSave>
          <Button
            event={Fechar}
            width={Poket ? "4rem" : "10rem"}
            placeholder={"fechar"}
            background={"linear-gradient(135deg, #1a2e35 0%, #263654 100%)"}
            borderRadius="10px"
            padding={!PC && "10px"}
            fontSize={!PC && "12px"}
          />
          {fileUrl && (
            <DragAndDropArea2 style={{ margin: "5px 15px" }}>
              <FileInfo>
                <span>
                  NOME:{" "}
                  {progressaoEdit.pdf && progressaoEdit.pdf.toLowerCase().includes(".pdf")
                    ? progressaoEdit.pdf?.split("_")[1]
                    : `${progressaoEdit.pdf?.split("_")[1]}.PDF`}
                </span>
                {fileSize.kb && (
                  <FileDetails>
                    Tamanho do arquivo: ({fileSize.kb} KB, {fileSize.mb} MB
                    {fileSize.gb > 0.01 ? `, ${fileSize.gb} GB` : ""})
                  </FileDetails>
                )}
              </FileInfo>
            </DragAndDropArea2>
          )}
        </DivSave>
      </Cardo>
    </Background>
  );
};

export default CardVerPdfEnviado;
